export default __webpack_public_path__ + "static/media/finish-dark.c54df1d8.svg";